<template>
    <b-container>
        <b-row class="mb-20">
            <label for="ttName" class="tt-edit-label"> Название*</label>                
            <b-form-input id="ttName" v-model="tradePoint.MdRetailChainName" />
        </b-row>

        <b-row class="mb-20">
            <label for="ttAddress" class="tt-edit-label"> Адрес </label>
            <b-form-input id="ttAddress" v-model="tradePoint.Address" />
        </b-row>

        <b-row class="mb-20">
            <label for="ttDaxId" class="tt-edit-label"> Дистрибьютер </label>
            <b-form-input id="ttDaxId" v-model="tradePoint.AccountName" />
        </b-row>

        <b-row class="mb-20">
            <label for="ttMdRetailChainId" class="mr-12 tt-edit-label center"> Сеть </label>
            <yes-no-input id="ttMdRetailChainId" class="m-0" v-model="tradePoint.MdRetailChainId" />
        </b-row>

        <b-row class="mb-20">
            <label for="ttSubType" class="tt-edit-label"> Тип торговой точки</label>
            <custom-multiselect id="ttSubType" v-model="tradePoint.SubType" :options="subTypes"/>
        </b-row>

        <b-row class="mb-20">
            <label for="ttSegmentCode" class="tt-edit-label"> Сегмент*</label>
            <custom-multiselect id="ttSegmentCode" v-model="tradePoint.SegmentCode" :options="segmentCodes"/>
        </b-row>

        <b-row class="mb-20">
            <label for="ttType" class="tt-edit-label"> Категория торговой точки* </label>
            <custom-multiselect id="ttType" v-model="tradePoint.Type" :options="types"/>
        </b-row>

        <b-row class="mb-20">
            <b-checkbox v-model="tradePoint.IsPriceMonitoring"
                                class="admin-checkbox"
                                :value="true"
                                :unchecked-value="false"
                                style="z-index:0">
                <label class="tt-edit-label ml-15"> PM </label>
            </b-checkbox>
        </b-row>

    </b-container>
    
</template>

<script>
import YesNoInput from '@/components/shared/YesNoInput'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import Consts from '@/store/models/consts/clientConsts'

export default {
    props: {
        tradePoint: {
            type: Object,
            default: {}
        }
    },
    data: function() {
        return {
            types: Consts.TradePointType.slice(0, -1),
            subTypes: Consts.TradePointSubType,
            segmentCodes: Consts.SegmentCodes
        }
    },
    components: {
        YesNoInput,
        CustomMultiselect
    }
}
</script>